import { render, staticRenderFns } from "./UpTable.vue?vue&type=template&id=46814485&scoped=true"
import script from "./UpTable.vue?vue&type=script&lang=js"
export * from "./UpTable.vue?vue&type=script&lang=js"
import style0 from "./UpTable.vue?vue&type=style&index=0&id=46814485&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46814485",
  null
  
)

export default component.exports